import React from 'react';
import { formatDateString } from '../../../constants/date';
import BuildingIcon from '../../../icons/BuildingIcon';
import SourceIcon from '../../../icons/SourceIcon';
import DestinationIcon from '../../../icons/DestinationIcon';
import CalendarGreyIcon from '../../../icons/CalendarGreyIcon';
import './style.scss';


interface MileageCardProps {
    main_category: {
        name: string;
        uuid: string
    };
    distance: string;
    source_name: string;
    destination_name: string;
    sub_activity: {
        name: string;
        uuid: string
    };
    property_name?: string;
    date: string;    
}

const MileageCard: React.FC<MileageCardProps> = ({ main_category, distance, source_name, destination_name, sub_activity, property_name, date }) => {

    return (
        <div className="mb-4">
            <div className="custom-card mx-auto">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <span
                            className={
                               main_category?.name.toLowerCase() == "material participation" ? "category-badge" : "category-badge yellow"}
                        >
                            {main_category?.name}
                        </span>

                        <div className="d-flex justify-content-end  time-text">
                            <span className="time-badge">
                                {distance} mi
                            </span>
                        </div>
                    </div>

                    <div className="mt-4 text-area d-flex justify-content-between align-items-center ">
                        <h5 className=" fw-bold mb-0 d-flex  flex-column">
                            <p className="home">
                                <SourceIcon />
                                {source_name}
                            </p>
                            <p className="ocean">
                                <DestinationIcon />
                                {destination_name}
                            </p>
                        </h5>
                    </div>
                    <p className="mb-1 mt-1">
                        {sub_activity?.name}
                    </p>
                    <div className="mt-3 ">
                        <span className="tag tag-red mb-2">
                            <BuildingIcon />{" "}
                            {property_name}
                        </span>
                        <span className="tag tag-blue">
                            <CalendarGreyIcon />{" "}
                            {formatDateString(date)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MileageCard;